import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import ToggleUnreadButton from 'Components/ComponentLibrary/Molecules/ToggleUnreadButton';
import useResource from 'Hooks/useResource';
import { useMessagesContext } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';
import useMessagesStatsContext from 'Context/MessagesStatsContext';
import { noop } from 'Helpers/PropTypes';

const useStyles = buildUseStyles('ThreadToggleUnreadButton', () => ({
  root: {},
}));

const ThreadToggleUnreadButton = ({
  className,
  resource,
  color,
  size,
  onChange,
  fullWidth,
  showLabel,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const ATTR_NAME = 'isUnread';
  const { refreshThreads } = useMessagesContext();
  const { handleMessagesStatsRefresh } = useMessagesStatsContext();
  const { setAttribute, resource: threadResource } = useResource(resource);

  const handleClick = async (event, value) => {
    event.preventDefault();
    event.stopPropagation();
    onChange();
    setAttribute(ATTR_NAME, value);
    await threadResource.submit();
    await refreshThreads();
    // This is not awaited because this just updates the message count in the left nav
    // and can be done without blocking
    handleMessagesStatsRefresh();
  };

  return (
    <ToggleUnreadButton
      className={classNames(className, classes.root)}
      value={threadResource.isTruthy('isUnread')}
      onChange={handleClick}
      color={color}
      size={size}
      fullWidth={fullWidth}
      showLabel={showLabel}
    />
  );
};

ThreadToggleUnreadButton.defaultProps = {
  className: '',
  color: 'primary',
  size: 'default',
  onChange: noop,
  fullWidth: false,
  showLabel: false,
};

ThreadToggleUnreadButton.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  color: PropTypes.string,
  size: PropTypes.string,
  onChange: PropTypes.func,
  fullWidth: PropTypes.bool,
  showLabel: PropTypes.bool,
};

export { ThreadToggleUnreadButton };
